"use client"; // Ini penting agar komponen ini menjadi Client Component

import * as React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// import NextAppDirEmotionCacheProvider from "../EmotionCache";
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter'
import AppTheme from "@/theme/AppTheme"; // Kita akan buat file ini selanjutnya

export default function ThemeRegistry({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AppRouterCacheProvider options={{ key: 'mui', enableCssLayer: true }}>
      <ThemeProvider theme={AppTheme}>
        {/* CssBaseline me-reset CSS dasar untuk konsistensi antar browser */}
        <CssBaseline />
        {children}
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
}
